import React, { useEffect, useState } from "react";
import { ChatLink } from "tsi-common-react/src/components/ChatLink/index";
import { getChatConnector } from "tsi-common-react/src/utils/chatConnector";
import { usePageURL, useStaticURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

export const ChatCard = (): React.ReactNode => {
    const staticURL = useStaticURL();
    const [isChatOnline, setIsChatOnline] = useState(false);
    const contactUsFormURL = usePageURL("contact_us_form");
    const homeURL = usePageURL("home");

    useEffect(() => {
        (async () => {
            const { isOnline } = await getChatConnector().init();
            setIsChatOnline(isOnline);
        })();
    }, []);

    if (!isChatOnline) {
        return null;
    }

    return (
        <>
            <img
                src={`${staticURL}svg/badge-chat-white.png`}
                alt=""
                loading="lazy"
                decoding="async"
            />
            <h3>
                <strong>{t`Chat`}</strong>
            </h3>
            <p>
                {t`Questions about our products or need advice before you buy? Chat with one of our specialists.`}
            </p>
            <ChatLink
                chatOnlineText={t`Chat`}
                chatOfflineLink={contactUsFormURL || homeURL}
            />
        </>
    );
};
